<template>
  <v-snackbar
    bottom
    multi-line
    v-model="display"
    :color="color"
    :timeout="timeout"
  >
  <br />
  <h2 class="center"> {{ title }} </h2>
  <div v-for="msg in messages" v-bind:key="msg">
    <div class="center">{{ msg }}</div>
     <br />
  </div>
  <v-btn outlined text @click="alertClosed">
    <div class="right">Close</div>
    
  </v-btn>
  </v-snackbar>
</template>

<script>
import { Status } from "@/constants";

export default {
  name: "status-ctrl",
  props: ["successMessage"],

  data: () => ({
    display: false,
    color: "success",
    messages: [],
    statusCode: 200,
    timeout: 500000,
  }),

  methods: {
    alertClosed() {
      this.display = false;
    },

    displayResult(result) {
      // console.log("displayResult()", result)
      this.statusCode = result.statusCode;
      this.display = true;
      this.color = this.statusCode === 200 ? Status.success : Status.error;
      this.messages = result.messages;
      this.title = result.title;
    },

    displayActionResult(result) {
      // console.log("ActionResult:", result);
      this.messages = [];
      this.display = true;
      if (result.status) {
        this.statusCode = result.status;
        if (this.statusCode === 200 || this.statusCode === 201) {
          this.messages.push(this.successMessage);
          this.color = "success";
        }
      } else if (result.response) {
        this.color = "error";
        this.statusCode = result.response.status;
        if (result.response.status === 400) {
          this.messages.push(result.response.data.title);
          for (var key in result.response.data.errors) {
            this.messages.push(result.response.data.errors[key]);
          }
        } else if (result.response.status === 401) {
          this.messages.push("Unathorized");
        } else if (result.response.status === 404) {
          this.messages.push(result.response.data.title);
        } else {
          this.messages.push("Unknown error");
        }
      } else {
        this.statusCode = 500;
        this.messages.push(
          "Error connecting to server, if this problem persists contact your administrator"
        );
        this.color = "error";
      }
    },
  },

  watch: {
    display() {
      if (!this.display) {
        this.$emit("closed", this.statusCode);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
}
.right {
  text-align: right;
}
.theme--light.v-btn {
  background-color: $light-background-color;
  color: $light-color;
}
.theme--dark.v-btn {
  background-color: $dark-background-color;
  color: $dark-color;
}</style>
